import { render, staticRenderFns } from "./Wp_c_test.vue?vue&type=template&id=6effd498&scoped=true&"
import script from "./Wp_c_test.vue?vue&type=script&lang=js&"
export * from "./Wp_c_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6effd498",
  null
  
)

export default component.exports